import { Button, Typography } from '@mui/material';
import { StackLayout } from '../initialPage/initialPageStyles';
import { ImageLoader } from '../imgLoader/imgLoader';
import Logo from '../../logo/logo.png';
import { useTranslation } from 'react-i18next';

export function VersionUpdate() {
  const { t } = useTranslation();

  const openUpdateApp = () => {
    if (window.cordova) {
      window.cordova.InAppBrowser.open('https://onelink.to/5htyta', '_system', 'location=yes');
    }
  };

  return (
    <StackLayout direction="column" justifyContent="center" alignItems="center">
      <ImageLoader sx={{ width: '200px', ml: '-20px' }} src={Logo} alt="Logotipas" />
      <Typography sx={{ color: 'white', textAlign: 'center', mt: '20px' }}>
        {t('info:newAppVersionAvailable')}
      </Typography>
      <Typography sx={{ color: 'white', textAlign: 'center', mb: '20px' }}>{t('info:requestAppUpdate')}</Typography>
      <Button onClick={openUpdateApp} variant="contained">
        {t('info:updateApp')}
      </Button>
    </StackLayout>
  );
}
